import { TFeedbackForm } from './../types/index.d';
import { Api, TResponse } from '@/modules/common';

export const feedbackServices = {
  apiGetFeedbackForm: (handle: string): Promise<TResponse<{ feedback: TFeedbackForm | null }>> => {
    return Api.base.get(`api/editor/feedback/getBy?handle=${handle}`);
  },
  apiFeedback: (payload: any): Promise<{}> => {
    return Api.base.post('/api/feedback/submit', payload);
  },
};
